import React from 'react';

import './ReturnJourneyDeleteModal.scss'
import {mmmddyyyy} from 'services/Dates';
import {educationAuthTokenUrls} from 'services/Externals';

const ReturnJourneyDeleteModal = ({createDate, accountDisplay, recievedDeleteError, failedCounter }) => {

  const printDate = mmmddyyyy(createDate);
  return (
    <div className="nasu-modal-body">
      {recievedDeleteError && failedCounter > 0 && (
        <div className="delete-line">
          There was an issue deleting your {accountDisplay} application. Please try again later. If the problem persists, you can
           {' '}
          <a
            className="error-page-link"
            href={educationAuthTokenUrls.contactUrl}
            rel="noreferrer"
            target="_blank"
          >
            Contact Us
          </a>
          .
        </div>
      )}
      {(!recievedDeleteError || failedCounter === 0) && (
        <div className="delete-line">
          Data saved to the {accountDisplay} application you started on <span className="date-line">{printDate}</span> will be erased.
        </div>
      )}
    </div>
  );
};


export default ReturnJourneyDeleteModal;
